interface MediaQueryStore {
  subscribe: (listener: () => void) => () => void;
  getSnapshot: () => boolean;
}

const stores = new Map<string, MediaQueryStore>();

export const getMediaQueryStore = (query: string) => {
  let store = stores.get(query);

  if (!store) {
    const media = window.matchMedia(query);

    store = {
      subscribe: (listener) => {
        media.addEventListener('change', listener);
        return () => {
          media.removeEventListener('change', listener);
        };
      },
      getSnapshot: () => media.matches,
    };
    stores.set(query, store);
  }

  return store;
};
